import { A_CURRENCY } from "@/src-refactor/modules/shared/model/const/currency.conts";
import { O_BUSINESS_TYPE } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import { HPreparePrice } from "@rf-helper/property/prepare-price-property";

export const prepareDetailPropertyCardPrice = (
  property: IPropertyDetailsResponse
) => {
  return HPreparePrice({
    alternativePrice: property?.alternate_price?.toString() ?? "",
    currencyAlternativePrice:
      A_CURRENCY.find(currency => currency.id === property?.currency_alternate_id)
        ?.label ?? "",
    currencyPrice:
      A_CURRENCY.find(currency => currency.id === property?.currency_id)?.label ??
      "",
    businessTypeId: O_BUSINESS_TYPE[property.business_type].id,
    isProject: Boolean(property.project),
    price: property.price,
    maximumPrice: property.project?.maximum_price
      ? property.project?.maximum_price.toString()
      : "",
    minimumPrice: property.project?.minimum_price
      ? property.project?.minimum_price.toString()
      : ""
  });
};
